<template>
  <el-table-column
    prop="sales"
    label="Szállítólevelek"
    min-width="180"
  >
    <template slot-scope="scope">
      <receipt-link
        v-for="order in (scope.row.related_data && scope.row.related_data.customerSales || [])"
        :id="order.id"
        :label="order.receipt_number"
        type="customerSale"
        style="display: inline-block; margin-right: 5px;"
      />
      <receipt-link
        v-for="order in (scope.row.related_data && scope.row.related_data.representativeDeliveries || [])"
        :id="order.id + '-representative'"
        :label="order.receipt_number"
        type="representativeDelivery"
        style="display: inline-block; margin-right: 5px;"
      />
    </template>
  </el-table-column>
</template>

<script>
import ReceiptLink from '../../../utils/ReceiptLink';

export default {
  components: {
    ReceiptLink,
  },
  propName: 'receipt_number',
};
</script>
